import { typeMatch } from './helpers';
import { isPublicApp } from '../utils/session';

const SCROLL_INTERVAL = 10;
const SCROLL_CHANGEBY = 50;

const getMainScrollableContainer = (): Nullable<HTMLElement> => {
  if(isPublicApp()){
    return document.querySelector('body');
  }
  else return document.querySelector('#main-content');
};

export const smoothScrollTo = (
  scrollTo: number,
  mainScrollableContainer: HTMLElement | Falsy,
  interval = SCROLL_INTERVAL,
  changeBy = SCROLL_CHANGEBY
): void => {
  const mainContent = mainScrollableContainer || getMainScrollableContainer();

  if (!mainContent) return;

  type Direction = -1 | 1;
  let intervalId: NodeJS.Timeout,
    currentYPositionOfMainContent = mainContent?.scrollTop || 0,
    direction: Direction;

  if (currentYPositionOfMainContent < scrollTo) direction = 1;
  else direction = -1;

  const changedPosition = (currentPosition: number, newDirection: Direction): number => {
    return currentPosition + newDirection * changeBy;
  };

  const isCurrentPositionInValid = (currentPosition: number, newDirection: Direction): boolean => {
    if (newDirection > 0) return currentPosition >= scrollTo;
    else return currentPosition <= scrollTo;
  };

  intervalId = setInterval(function () {
    currentYPositionOfMainContent = changedPosition(currentYPositionOfMainContent, direction);
    if (isCurrentPositionInValid(currentYPositionOfMainContent, direction)) {
      currentYPositionOfMainContent = scrollTo;
      clearInterval(intervalId);
    }
    mainContent?.scrollTo(0, currentYPositionOfMainContent);
  }, interval);
};

/**
 * Use this method to smoothly scroll to an Element
 * @param toElement Element where the scroll should goto
 * @param interval Interval in ms, after which the scroll position changes, increasing this will slow down the scroll
 * @param changeBy Increment of the scroll position if going down or Decrement of the scroll position if going up, this change happens after each interval
 * @param offSetYcoordsDirection
 * @param mainScrollableContainer The topmost scrollable parent of the element
 */
export const smoothScrollToElement = (
  toElement: Nullable<HTMLElement> | string,
  interval = SCROLL_INTERVAL,
  changeBy = SCROLL_CHANGEBY,
  offSetYcoordsDirection: 1 | -1 = 1,
  mainScrollableContainer?: HTMLElement,
): void => {
  const mainContent = mainScrollableContainer || getMainScrollableContainer();
  toElement = typeMatch(toElement, 'string') ? document.getElementById(toElement as string) : toElement;

  if (!mainContent || !toElement) return;

  const scrollTopOfMainContainer = mainContent.scrollTop || 0;
  const boundingRectOfElement = (toElement as HTMLElement).getBoundingClientRect();
  const { y } = boundingRectOfElement;
  let yCoords = y + scrollTopOfMainContainer - (70 * offSetYcoordsDirection);
  smoothScrollTo(yCoords, mainContent, interval, changeBy);
};
